import { HelpersModule } from "../helpers/helpers";
import { UrlHelperModule } from "../helpers/urlHelper";

const helpersModule = new HelpersModule();

export class DropdownFindersModule {

    constructor() {
        this.init();
    }

    create_custom_dropdowns() {
        var _this = this;

        // Setup all data for each dropdown
        $('.search-dropdown').each(function () {

            var _container = this;
            var url = apilocation + $(this).data("url");

            fetch(url)
                .then(function (response) {
                    response.json().then(data => ({
                        data: data,
                        status: response.status
                    })
                    ).then(res => {
                        var data = JSON.parse(res.data);
                        var _selectedId = $(_container).find("input[type=hidden]").val();
                        var _selectedText = "Please select";
                        $(_container).find(".dropdown-select").find("ul li").removeClass("selected");
                        $.each(data.Suggestions, function (index, item) {
                            var _value = "<li class='option' data-value='" + item.NodeId + "' data-display-text='' tabindex='0'>" + item.Display + "</li>";
                            if (_selectedId == item.NodeId) {
                                _value = "<li class='option selected' data-value='" + item.NodeId + "' data-display-text='' tabindex='0'>" + item.Display + "</li>";
                                _selectedText = item.Display;
                            }
                            $(_container).find(".dropdown-select").find("ul").append(_value);
                        });

                        $(_container).find(".dropdown-select").find(".current").html(_selectedText);

                    });
                });
            
        });

        $('.search-dropdown').find("select").each(function (i, select) {
            if (!$(this).next().hasClass('dropdown-select')) {
                $(this).after('<div class="dropdown-select wide ' + ($(this).attr('class') || '') + '" tabindex="0"><span class="current"></span><div class="list"><ul></ul></div></div>');
                var dropdown = $(this).next();
                var options = $(select).find('option');
                var selected = $(this).find('option:selected');
                dropdown.find('.current').html(selected.data('display-text') || selected.text());
                options.each(function (j, o) {
                    var display = $(o).data('display-text') || '';
                    dropdown.find('ul').append('<li class="option ' + ($(o).is(':selected') ? 'selected' : '') + '" data-value="' + $(o).val() + '" data-display-text="' + display + '">' + $(o).text() + '</li>');
                });
            }
        });

        $('.dropdown-select ul').before('<div class="dd-search"><input placeholder="Search" autocomplete="off" class="dd-searchbox" type="text"></div>');

        $(".dropdown-select").delegate(".dd-searchbox", 'keyup', function (e) {
            _this.filter(this);
        });

        // Open/close
        $(document).on('click', '.dropdown-select', function (event) {
            if ($(event.target).hasClass('dd-searchbox')) {
                return;
            }
            var _this = this;
            //$('.dropdown-select').not($(this)).removeClass('open');
            $(_this).not($(this)).removeClass('open');
            $(this).toggleClass('open');
            if ($(this).hasClass('open')) {
                $(this).find('.option').attr('tabindex', 0);
                $(this).find('.selected').trigger('focus');
            } else {
                $(this).find('.option').removeAttr('tabindex');
                $(this).trigger('focus');
            }
        });

        // Close when clicking outside
        $(document).on('click', function (event) {
            if ($(event.target).closest('.dropdown-select').length === 0) {
                $('.dropdown-select').removeClass('open');
                $('.dropdown-select .option').removeAttr('tabindex');
            }
            event.stopPropagation();
        });

        // Option click
        $(document).on('click', '.dropdown-select .option', function (event) {
            $(this).closest('.list').find('.selected').removeClass('selected');
            $(this).addClass('selected');
            var text = $(this).data('display-text') || $(this).text();
            var nodeid = $(this).data('value');
            $(this).parent().parent().parent().parent().find('input[type=hidden]').first().val(nodeid); // might need to get id
            $(this).closest('.dropdown-select').find('.current').text(text);
            $(this).closest('.dropdown-select').prev('select').val($(this).data('value')).trigger('change');
        });

        // Keyboard events
        $(document).on('keydown', '.dropdown-select', function (event) {
            var focused_option = $($(this).find('.list .option:focus')[0] || $(this).find('.list .option.selected')[0]);
            // Space or Enter
            //if (event.keyCode == 32 || event.keyCode == 13) {
            if (event.keyCode == 13) {
                if ($(this).hasClass('open')) {
                    focused_option.trigger('click');
                } else {
                    $(this).trigger('click');
                }
                return false;
                // Down
            } else if (event.keyCode == 40) {
                if (!$(this).hasClass('open')) {
                    $(this).trigger('click');
                } else {
                    focused_option.next().trigger('focus');
                }
                return false;
                // Up
            } else if (event.keyCode == 38) {
                if (!$(this).hasClass('open')) {
                    $(this).trigger('click');
                } else {
                    var focused_option = $($(this).find('.list .option:focus')[0] || $(this).find('.list .option.selected')[0]);
                    focused_option.prev().trigger('focus');
                }
                return false;
                // Esc
            } else if (event.keyCode == 27) {
                if ($(this).hasClass('open')) {
                    $(this).trigger('click');
                }
                return false;
            }
        });

    }

    filter(e) {

        var valThis = $(e).val();
        var _p = $(e).parent().parent().parent().parent();
        $(_p).find('ul > li').each(function () {
            var text = $(this).text();
            (text.toLowerCase().indexOf(valThis.toLowerCase()) > -1) ? $(this).show() : $(this).hide();
        });
    };

    init() {

        this.create_custom_dropdowns();

    }
}
